// extracted by mini-css-extract-plugin
export default {"container":"BooksContainer_container__9ebsu","wrapper":"BooksContainer_wrapper__fgKTp","button":"BooksContainer_button__vSWFU","loader":"BooksContainer_loader__+Op6M"};